import carrierCreateComponent from './carrier.create.component';

let carrierCreateModule = angular.module('carriercreate', [
  ])

  .component('carriercreate', carrierCreateComponent)

  .name;

export default carrierCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/carrier/create/index.js